module.exports = __webpack_public_path__ + "static/picTile3-dd3c69768975f1252b012292781afd0a.jpg";